// ============================================================
// QUIZ CONFIG — "Qual Eu está no comando?" — Clube do Eu
// ============================================================

export const QUIZ_META = {
  titulo: 'Qual Eu está no comando?',
  subtitulo: '7 perguntas para descobrir qual parte de você está carregando o peso agora — e o que isso diz sobre o que você precisa.',
  tempo: '2 minutos',
  botaoIniciar: 'Quero descobrir →',
};

export const PERGUNTAS = [
  {
    id: 1,
    texto: 'Quando você finalmente tem um tempo livre, o que costuma acontecer?',
    opcoes: {
      A: 'Durmo ou fico sem energia pra fazer qualquer coisa',
      B: 'Já fico pensando em tudo que ainda preciso resolver ou melhorar',
      C: 'Prefiro ficar sozinha, não tenho vontade de estar perto de ninguém',
      D: 'Acabo usando esse tempo pra resolver algo de outra pessoa',
      E: 'Nem percebo, o tempo passa e eu nem sei o que fiz com ele',
    },
  },
  {
    id: 2,
    texto: 'Como você reage quando alguém elogia algo que você fez?',
    opcoes: {
      A: "Penso 'ainda bem que terminei, tava exausta'",
      B: 'Já penso no que poderia ter sido melhor',
      C: 'Fico sem graça e tento mudar de assunto rápido',
      D: 'Devolvo o elogio pra outra pessoa que também ajudou',
      E: 'Agradeço no automático, sem sentir muita coisa',
    },
  },
  {
    id: 3,
    texto: 'O que mais te incomoda na sua rotina atual?',
    opcoes: {
      A: 'Sinto que não durmo o suficiente nem descanso de verdade',
      B: 'Sinto que nunca é suficiente, sempre falta algo pra ser perfeito',
      C: 'Sinto que evito situações onde preciso me expor ou opinar',
      D: 'Sinto que cuido de todo mundo e ninguém pergunta como eu estou',
      E: 'Sinto que faço tudo por hábito, sem sentir conexão com nada',
    },
  },
  {
    id: 4,
    texto: 'Se você pudesse cancelar um compromisso hoje sem culpa, qual seria?',
    opcoes: {
      A: 'Qualquer coisa que exija energia física ou mental',
      B: 'Não cancelaria, eu me cobro demais pra deixar passar',
      C: 'Uma reunião ou encontro onde eu precisaria falar na frente de gente',
      D: 'Algo que é meu, porque sempre priorizo o compromisso dos outros primeiro',
      E: 'Sinceramente nem lembro dos meus compromissos direito',
    },
  },
  {
    id: 5,
    texto: 'Qual frase soa mais com a sua cabeça nos últimos meses?',
    opcoes: {
      A: "'Eu só preciso de um descanso de verdade'",
      B: "'Eu devia estar fazendo mais, ou fazendo melhor'",
      C: "'Prefiro não me expor, é mais seguro'",
      D: "'Se eu não fizer, quem vai fazer?'",
      E: "'Acho que faz tempo que eu não paro pra pensar em mim'",
    },
  },
  {
    id: 6,
    texto: 'Quando alguém discorda de você, o que costuma acontecer por dentro?',
    opcoes: {
      A: 'Não tenho energia pra discutir, prefiro deixar quieto',
      B: 'Já começo a questionar se eu estava errada',
      C: 'Evito o confronto, prefiro concordar pra não criar atrito',
      D: 'Penso primeiro em como isso afeta a outra pessoa, não em mim',
      E: 'Sigo a conversa meio no piloto automático, sem processar muito',
    },
  },
  {
    id: 7,
    texto: "Se você fechasse os olhos agora e pensasse em 'eu', a primeira imagem que vem é de alguém...",
    opcoes: {
      A: 'Cansada, mas que segue',
      B: 'Que está sempre se cobrando pra dar conta de tudo',
      C: 'Que prefere passar despercebida',
      D: 'Que está sempre cuidando de alguém',
      E: 'Que nem sabe direito quem é nesse momento',
    },
  },
];

export const RESULTADOS = {
  A: {
    nome: 'Eu Cansado',
    texto: 'Esse eu carrega o peso de fazer tudo funcionar mesmo sem combustível. Ele não é preguiça, é desgaste acumulado que ninguém parou pra olhar de frente. A pergunta que vale a pena se fazer agora não é como produzir mais, é onde está vazando a energia que você já tem.',
  },
  B: {
    nome: 'Eu Cobrador',
    texto: 'Esse eu trabalha em dobro: faz a tarefa e ainda julga como ela foi feita. Ele costuma se disfarçar de alta performance, mas no fundo é medo de não ser suficiente. O que muda tudo aqui não é baixar o padrão, é entender de onde veio essa régua tão alta.',
  },
  C: {
    nome: 'Eu Escondido',
    texto: 'Esse eu aprendeu, em algum momento, que ocupar espaço dá trabalho ou dá problema. Ele se protege ficando pequeno, mesmo quando tem muito a dizer. A pergunta que ele evita é simples: o que vai acontecer se eu parar de me esconder?',
  },
  D: {
    nome: 'Eu Cuidadora',
    texto: 'Esse eu sabe exatamente o que todo mundo ao redor precisa, menos o que ela mesma precisa. Ele costuma ser muito amado por fora e muito cansado por dentro. O ponto de virada aqui é perceber que cuidar de si não é abandonar quem você ama.',
  },
  E: {
    nome: 'Eu no Automático',
    texto: 'Esse eu segue a rotina porque é o que se faz, sem muita pergunta sobre o porquê. Ele não está em crise, está apenas desconectado do próprio motor. A primeira pergunta que vale resgatar é: quando foi a última vez que eu escolhi alguma coisa de verdade, em vez de só seguir o fluxo?',
  },
};

export const CTA_FINAL = 'Esse é só um retrato de um momento, não uma sentença. Dentro do Clube do Eu a gente trabalha exatamente esse tipo de reconhecimento, com conteúdo, comunidade e acompanhamento pra você sair do piloto automático de verdade. Quer entrar no nosso grupo no WhatsApp?';

export const CTA = {
  botao: 'Entrar no grupo do WhatsApp →',
  url: 'https://chat.whatsapp.com/Dc3INZBnb9zA4rwgqoRHiy?mode=gi_t',
};

/**
 * Calcula o resultado a partir das respostas.
 * @param {Object} respostas - ex: { 1: "A", 2: "B", 3: "A", ... }
 * @returns {Object}
 */
export function calcularResultado(respostas) {
  const contagem = { A: 0, B: 0, C: 0, D: 0, E: 0 };

  Object.values(respostas).forEach((letra) => {
    if (contagem[letra] !== undefined) contagem[letra]++;
  });

  const ranking = Object.entries(contagem).sort((a, b) => b[1] - a[1]);
  const [letraPrincipal, votosPrincipal] = ranking[0];
  const [letraSegunda, votosSegunda] = ranking[1];
  const empate = votosPrincipal === votosSegunda && votosPrincipal > 0;

  if (empate) {
    return {
      letra: letraPrincipal,
      letraSecundaria: letraSegunda,
      empate: true,
      resultadoPrincipal: RESULTADOS[letraPrincipal],
      resultadoSecundario: RESULTADOS[letraSegunda],
      contagem,
    };
  }

  return {
    letra: letraPrincipal,
    empate: false,
    resultadoPrincipal: RESULTADOS[letraPrincipal],
    contagem,
  };
}

export function respostasCompletas(respostas) {
  return PERGUNTAS.every((p) => respostas[p.id] !== undefined);
}
